/**
 * /**
 * Created by Jie Gao on 2020-01-13.
 * Modified by Jerker Nord on 2020-01-31.
 */
require("pixi-particles");
import {Emitter} from "pixi-particles";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {TweenLite} from "gsap";
import {StageEvent} from "@nolimitcity/slot-game/bin/core/stage/event/StageEvent";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";


export class BonusBunniesParticleManager {

    private static _instance:BonusBunniesParticleManager;
    private static _emitters:Emitter[];
    private static _elapsed:number;

    private constructor() {
        if(BonusBunniesParticleManager._instance) {
            debugger;
            throw new Error("Error: LeParticlesManager.constructor() - Instantiation failed: Singleton.");
        }

        BonusBunniesParticleManager._instance = this;
        BonusBunniesParticleManager._emitters = [];
        EventHandler.dispatchEvent(new GameEvent(StageEvent.ADD_TO_RENDER_LOOP, () => this.update()));
    }

    private createMainLoop():void {
        TweenLite.ticker.addEventListener("tick", this.animate, this);
    }

    private handleContextLost(event:WebGLContextEvent) {
        TweenLite.ticker.removeEventListener("tick", this.animate, this);
        Logger.logDev(event.type, event);
    }

    private update():void {
        if(!BonusBunniesParticleManager._instance) {
            new BonusBunniesParticleManager();
        }

        if(BonusBunniesParticleManager._emitters.length === 0) {
            return;
        }

        let now:number = Date.now();
        for(let i:number = 0; i < BonusBunniesParticleManager._emitters.length; i++) {
            BonusBunniesParticleManager._emitters[i].update((now - BonusBunniesParticleManager._elapsed) * 0.001);
        }
        BonusBunniesParticleManager._elapsed = now;
    }

    private animate():void {
        this.update();
    }


    public static addEmitter(emitter:Emitter, start:boolean = true):void {
        if(!BonusBunniesParticleManager._instance) {
            new BonusBunniesParticleManager();
        }
        this._instance.createMainLoop();
        BonusBunniesParticleManager._emitters.push(emitter);
        emitter.emit = start;
        BonusBunniesParticleManager._elapsed = Date.now();
        BonusBunniesParticleManager._instance.update();
    }

    public static removeEmitter(emitter:Emitter, forceCleanUpWhenEmpty:boolean = false):boolean {
        if(!BonusBunniesParticleManager._instance) {
            new BonusBunniesParticleManager();
        }
        const index:number = BonusBunniesParticleManager._emitters.indexOf(emitter);
        if(index === -1) {
            return false;
        }
        BonusBunniesParticleManager._emitters.splice(index, 1);
        emitter.emit = false;
        emitter.destroy();
        // emitter = null;
        BonusBunniesParticleManager._elapsed = Date.now();
        BonusBunniesParticleManager._instance.update();
        if(forceCleanUpWhenEmpty && BonusBunniesParticleManager._emitters.length === 0) {
            //TODO - This does not work in PIXI v5, so another solution is needed.
            //  StageManager.renderer.plugins.sprite.sprites.length = 0;
        }
        return true;
    }
}